import { FileText } from "lucide-react";
import { inputCls, labelCls } from "./constants";

export default function RegulaminSection({ pages, setPages }) {
  return (
    <section>
      <h3 className="flex items-center gap-2 font-bold text-slate-800 text-lg mb-4">
        <FileText size={18} className="text-[#1f3a8a]" /> Regulamin
      </h3>
      <div className="rounded-xl border border-slate-200 p-5 bg-slate-50/50 space-y-4">
        <div className="grid md:grid-cols-2 gap-3">
          <div>
            <label className={labelCls}>Tytuł</label>
            <input data-testid="reg-title" className={inputCls} value={pages.regulamin.title} onChange={(e) => setPages({ ...pages, regulamin: { ...pages.regulamin, title: e.target.value } })} />
          </div>
          <div>
            <label className={labelCls}>Podtytuł (np. data aktualizacji)</label>
            <input data-testid="reg-subtitle" className={inputCls} value={pages.regulamin.subtitle} onChange={(e) => setPages({ ...pages, regulamin: { ...pages.regulamin, subtitle: e.target.value } })} />
          </div>
        </div>
        <div>
          <label className={labelCls}>Treść regulaminu</label>
          <p className="text-xs text-slate-500 mb-2">
            Każda linia zaczynająca się od <code className="bg-slate-100 px-1 rounded">## </code> to tytuł sekcji.
            Pozostałe linie to zwykłe paragrafy. Puste linie oddzielają sekcje.
          </p>
          <textarea
            data-testid="reg-body"
            className={`${inputCls} font-mono text-xs leading-relaxed`}
            rows={20}
            value={pages.regulamin.body}
            onChange={(e) => setPages({ ...pages, regulamin: { ...pages.regulamin, body: e.target.value } })}
          />
        </div>
      </div>
    </section>
  );
}
